const faqs = [
  {
    id: 1,
    question: "How long does it take to set up the app?",
    answer:
      "The app setup process is quick and easy. Once you install the app, the setup process starts right away. If you have the API key from Faire, the process will not take more than a minute or two. If you do not have an API key, you need to request it from Faire, which will factor in the setup time.",
  },
  {
    id: 2,
    question: "How to get the Faire API key?",
    answer: `To get the Faire API key, you need to send an email to (support@faire.com) from your email registered in the Faire account. Here’s a sample below:

    Hello Faire team,
    
    Please provide us with our brand’s API key so that we can integrate with the Faire Integration & Import. Our account information is listed below:
    
    Brand Name
    Email
    Contact Number
    Thanks,
    Your name`,
  },
  {
    id: 3,
    question: "How does inventory management work between Wix and Faire?",
    answer: `Wix Faire Integration allows you to manage your inventory based on SKUs. Your primary source of inventory will be Wix, and the app syncs inventory between Wix and Faire. This ensures that the inventory levels are accurate and updated across both platforms.`,
  },
  {
    id: 4,
    question: "How can the app help Wix store owners manage their Faire transactions?",
    answer: `With the Wix Faire Integration app, store owners can easily sync products, orders, and inventory between Wix and Faire from a single dashboard, streamlining inventory and order management and ensuring consistency across platforms.`,
  },
  {
    id: 5,
    question: "How do I export Wix products to Faire using the Wix Faire Integration app?",
    answer: `To export Wix products to Faire, select the desired products from your Wix Products page and select a product category. The app will handle the synchronization and ensure your products are listed on Faire with accurate information.`,
  },
  {
    id: 6,
    question: "How do I upload Faire products into Wix?",
    answer: `To upload Faire products into Wix, select the desired products individually or in bulk from the Faire products page and export the Faire products into your Wix store.`,
  },
  {
    id: 7,
    question: "How are orders synced?",
    answer: `The app fetches orders from Faire in real time, ensuring that the order information is promptly updated within the app. This real-time synchronization enables you to efficiently manage and fulfill orders with accurate and up-to-date data from your Wix Store. `,
  },
  {
    id: 8,
    question: "Is the app suitable for all Wix and Faire store sizes?",
    answer: `Yes, the Wix Faire Integration app is designed to be suitable for stores of all sizes, from small businesses to large enterprises. It offers scalability and flexibility to meet the needs of various store setups.`,
  },
  {
    id: 9,
    question: "What will happen if I face an error during product transfer?",
    answer: `If you encounter an error while transferring products, the app will immediately identify the issue and display the possible reason. You can then follow the provided information to resolve the problem, and once resolved, you can easily re-export the products.`,
  },
];

export default faqs;
